@let fieldData = field();
@let isMobile = deviceService.isMobile$ | async;

<div class="mb-6">
  @if (fieldData.title) {
    <label
      class="block x-font-body-3 x-text-wf-title mb-2"
      [class.font-extrabold!]="fieldData.isHighlighted"
    >
      {{ fieldData.title }}
      @if (fieldData.helpText) {
        <tui-icon [tuiTooltip]="fieldData.helpText"></tui-icon>
      }
    </label>
  }

  @for (file of fieldData.files; track file.src; let index = $index) {
    <div class="text-center mb-4 flex flex-col items-center">
      <img
        [src]="file.src"
        [alt]="file.title || ''"
        class="rounded cursor-pointer hover:opacity-80 transition-opacity max-w-[400px] w-full h-auto"
        (click)="showPreview(index)"
      />
      @if (file.title) {
        <p class="x-font-body-4 x-text-dark-75 mt-1">{{ file.title }}</p>
      }
    </div>
  }
</div>

<ng-template #imagePreview let-observer>
  <tui-preview
    [rotatable]="true"
    [zoomable]="true"
    (click)="backdropClickClose($event, observer)"
    (tuiSwipe)="onSwipePreview($event)"
  >
    @if (currentFile.title) {
      <tui-preview-title>{{ currentFile.title }}</tui-preview-title>
    }
    <tui-preview-pagination
      [length]="previewLength"
      [(index)]="currentPreviewIndex"
    ></tui-preview-pagination>
    <button
      iconStart="@tui.x"
      title="Close"
      tuiIconButton
      tuiPreviewAction
      type="button"
      (click)="closePreview(observer)"
    ></button>
    <img [alt]="currentFile.title || ''" [src]="currentFile.src" />
    @if (isMobile) {
      <div
        class="mt-4 x-text-primary text-center absolute top-10"
        tuiPreviewAction
      >
        <h4 class="x-font-body-3-bold cursor-pointer">
          {{ currentFile.title }}
        </h4>
      </div>
    }
  </tui-preview>
</ng-template>
